import * as ImageManipulator from 'expo-image-manipulator';

const HEIC_LIKE = new Set(['heic', 'heif']);

/** Convert HEIC/HEIF images to JPEG before upload. Returns the original URI
 *  unchanged for other formats or already-remote URLs. */
export async function ensureJpegImage(uri: string): Promise<string> {
  if (!uri) return uri;
  if (uri.startsWith('http') || uri.startsWith('data:')) return uri;
  const clean = uri.split(/[?#]/)[0];
  const ext = clean.split('.').pop()?.toLowerCase() || '';
  if (!HEIC_LIKE.has(ext)) return uri;

  const result = await ImageManipulator.manipulateAsync(
    uri,
    [],
    { compress: 0.92, format: ImageManipulator.SaveFormat.JPEG },
  );
  return result.uri;
}

/** Build a FormData-ready file object from a local image URI, converting
 *  HEIC/HEIF to JPEG in the process. */
export async function prepareLocalImage(uri: string): Promise<{ uri: string; name: string; type: string }> {
  const convertedUri = await ensureJpegImage(uri);
  const rawName = convertedUri.split('/').pop() || '';
  const fileName = rawName.split(/[?#]/)[0];
  const extMatch = fileName.match(/\.([a-zA-Z0-9]+)$/);
  // ponytail: data: URIs and extension-less paths yield the base64 tail as the
  // "filename" — the API keys R2 objects by filename, so duplicate tails (e.g.
  // "9k=" and "Z", common JPEG endings) overwrite each other. Upgrade path:
  // unique-ify keys server-side instead.
  if (!extMatch) {
    return { uri: convertedUri, name: `image_${Date.now()}_${Math.random().toString(36).slice(2, 8)}.jpg`, type: 'image/jpeg' };
  }
  const ext = extMatch[1].toLowerCase();
  const mimeType = ext === 'png' ? 'image/png' : 'image/jpeg';
  return { uri: convertedUri, name: fileName, type: mimeType };
}
